module.exports = __webpack_public_path__ + "static/media/icon-radio-flag.64640ce8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-radio-flag.svg
// module id = 2898
// module chunks = 0